import { useState } from 'react'
import { useStyles } from './search-input.style'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSearch } from '@fortawesome/pro-solid-svg-icons'

export const SearchInput = function ({
  enableFocusAnimation = true,
  _ref,
  className = '',
  setReportSearchFilter,
  labelPlaceholder = '',
  ...props
}) {
  const classes = useStyles()
  const [isFocused, setIsFocused] = useState(false)

  const containerClasses = (function () {
    if (labelPlaceholder) {
      return `form-element-wrapper ${classes.searchBar} ${
        isFocused ? classes.focused : ''
      }`
    } else {
      return `form-element-wrapper ${
        classes.inputContainer
      } ${isFocused ? classes.focused : ''}`
    }
  })()

  const inputClasses = (function () {
    if (labelPlaceholder) {
      return `${classes.inputAlt} ${className}`
    } else {
      return `${classes.input} ${className}`
    }
  })()

  function handleFocus () {
    setIsFocused(true)
  }

  function handleBlur () {
    setIsFocused(false)
  }

  return (
    <div className={containerClasses}>
      {labelPlaceholder ? '' : <FontAwesomeIcon color={'#cccccc'} icon={faSearch}/> }
      <input
        type="search"
        className={inputClasses}
        ref={_ref}
        {...props}
        onFocus={handleFocus}
        onBlur={handleBlur}
      />
      {enableFocusAnimation && <div className="form-element-border"></div>}{' '}
      {labelPlaceholder ? (
        <span className={classes.labelLocal}>{labelPlaceholder}</span>
      ) : (
        ''
      )}
    </div>
  )
}
